<template>
  <ul role="menu">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: 'i-menu-list',
};
</script>

<style scoped lang='scss'>
  ul {
    position: absolute;
    z-index: 1000;
    min-width: 160px;
    padding: 0;
    margin: 2px 0 0;
    list-style: none;
    font-size: 14px;
    line-height: 30px;
    text-align: left;
    background-color: #fff;
    border: 1px solid #ccc;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 0;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);

    &.pull-right {
      right: 0;
      left: auto;
    }
    &.pull-top {
      bottom: 27px;
    }
  }
</style>
